import React from 'react';
import Incendie from "../Pages/image/Incendie.jpeg";
import Secourisme from "../Pages/image/Secourisme.jpg";
import Prevention from "../Pages/image/Prevention.jpg";

const backgroundImage = (formation) => {
  const imageUrl =
    formation.training_cycle.id === 1
      ? Incendie
      : formation.training_cycle.id === 2
        ? Secourisme
        : Prevention;

  return `linear-gradient(rgba(23, 32, 58, 0.7), rgba(23, 32, 58, 0.7)), url("${imageUrl}")`;
};

const CourseCard = (course) => (

  <a href={"/formation/" + course.course.id} className="col-md-4 mb-4">
    <div>
      <div className="card ssip3-card" style={{
        backgroundImage: backgroundImage(course.course),
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "#17203a", // Couleur de secours si l'image ne charge pas
      }}>
        <div className="card-body text-center">
          <div className="ssip3-overlay">
            <h1 className="ssip3-title">{course.course.name.replace(/Inter-Entreprise|Intra-Entreprises|Intra-Entreprise|- Inter-Entreprises et individuels|- Inter-Entreprises et Individuels| - Intra-Entreprise|- Inter|s et Individuels/g, "").trim()}</h1>
          </div>
          {course.course.training_cycle.id === 1 ? (
            <div className="ssip3-tag">Incendie</div>
          ) : course.course.training_cycle.id === 2 ? (
            <div className="ssip3-tag-2">Secourisme</div>
          ) : (<div className="ssip3-tag-3">Prévention des risques</div>)}
        </div>
      </div>
    </div></a>
);
export default CourseCard;